import { Formik, Field } from "formik";
import * as yup from "yup";
import { ButtonPageLayout } from "../common/ButtonPageLayout";
import { Input } from "../common/Input";
import styles from "./ChangePasswordForm.module.scss";
import { useMutation } from '@apollo/client';
import { UPDATE_PASSWORD_WITH_HASH } from '../../apollo/queries';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';

interface Values {
  password: string;
  confirmPassword: string;
}

const initialeFormValues = {
  password: "",
  confirmPassword: ""
};

const validationSchema = yup.object().shape({
  password: yup.string().required(),
  confirmPassword: yup.string().oneOf([yup.ref("password"), null])
});

export const ChangePasswordFrom = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash")
  const [changePassword] = useMutation(UPDATE_PASSWORD_WITH_HASH, {
    onCompleted: () => {
      navigate("/login", { replace: true });
    },
  });

  if(!hash) {
    return <Navigate to='/login'  />
  }

  const changePasswordUser = (password: string) => {
    changePassword({
      variables: {
        updatePasswordWithHashInput: {
          hash,
          password
        },
      },
    });
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialeFormValues}
      onSubmit={(values: Values) => {
        const { password } = values;
        changePasswordUser(password);
      }}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <form className={styles.formContainer} onSubmit={handleSubmit}>
          <div className={styles.passwordContainer}>
            <Field
              name='password'
              as={Input}
              type='password'
              placeholder='Password'
              onChange={handleChange}
              value={values.password}
            />
          </div>
          <div className={styles.confirmPasswordContainer}>
            <Field
              name='confirmPassword'
              as={Input}
              type='password'
              placeholder='Password repeat'
              onChange={handleChange}
              value={values.confirmPassword}
            />
          </div>
          <ButtonPageLayout type='submit'>Change</ButtonPageLayout>
        </form>
      )}
    </Formik>
  );
};
